import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';

/**
 * Scrollable aside container for the subnav parallel-route slot in the admin shell.
 * Renders nothing when children is falsy.
 *
 * @param props.children - Subnav content rendered inside the scrollable region.
 */
export function SubNavSlot(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  if (!children) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <aside className="flex h-full min-w-0 flex-col border-0 border-none bg-background"><ScrollArea className="h-full"><div className="flex flex-col gap-1 p-3">{children}</div></ScrollArea></aside>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}